import classNames from 'classnames/bind';

import styles from './Vegan.module.scss';
import { VEGAN_FEATURES } from '../constants';

const cx = classNames.bind(styles);

const Vegan = () => {
  return (
    <div className={cx('container')}>
      <ul className={cx('campaign')}>
        {VEGAN_FEATURES.map((feature, index) => (
          <li key={index}>
            <img src={feature.icon} alt={`비동물성 ${feature.title}`} />
            <p className={cx('title')}>
              비동물성
              <br />
              {feature.title}
            </p>
          </li>
        ))}
      </ul>
      <p className={cx('desc')}>
        EVE (Expertise Vegane Europe)는 프랑스 비건협회 (Vegan France Interpro)가 설립한 권위있는 국제 비건 인증 기관으로, 제품 뿐만 아니라
        해당 제품을 제조하는 제조 현장까지 철저한 검증을 진행하고 있습니다. EVE VEGAN 인증은 생명 존중의 가치를 지키기 위해 동물성 원료를
        배제하고 비동물성 원료 패키지를 적용한 제품에 부여됩니다.
      </p>
      <p className={cx('desc')}>
        르브레 멀티밤 제품은 원료부터 생산과정, 패키지까지 까다롭고 엄격하게 심사하는 EVE VEGAN의 인증 절차를 정식으로 통과하였습니다.
      </p>
      <div className={cx('logos')}>
        <img className={cx('logo')} src={require('../../../asset/images/detail/common/vegan-logo.png')} alt="eve vegan" />
        <img className={cx('logo')} src={require('../../../asset/images/detail/common/vegan-cert.jpg')} alt="eve vegan" />
      </div>
    </div>
  );
};

export default Vegan;
